/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Created_On_LabelInputs */

const en_snapshot_history_created_on_label = /** @type {(inputs: Snapshot_History_Created_On_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created On`)
};

const fr_snapshot_history_created_on_label = /** @type {(inputs: Snapshot_History_Created_On_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cree le`)
};

const de_snapshot_history_created_on_label = /** @type {(inputs: Snapshot_History_Created_On_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt am`)
};

const it_snapshot_history_created_on_label = /** @type {(inputs: Snapshot_History_Created_On_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creato il`)
};

const ru_snapshot_history_created_on_label = /** @type {(inputs: Snapshot_History_Created_On_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создано в`)
};

const es_snapshot_history_created_on_label = /** @type {(inputs: Snapshot_History_Created_On_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creado el`)
};

const zh_cn2_snapshot_history_created_on_label = /** @type {(inputs: Snapshot_History_Created_On_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建于`)
};

const ja_snapshot_history_created_on_label = /** @type {(inputs: Snapshot_History_Created_On_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成日`)
};

const hi_snapshot_history_created_on_label = /** @type {(inputs: Snapshot_History_Created_On_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पर बनाया`)
};

const pt_pt2_snapshot_history_created_on_label = /** @type {(inputs: Snapshot_History_Created_On_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criado em`)
};

/**
* | output |
* | --- |
* | "Created On" |
*
* @param {Snapshot_History_Created_On_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_created_on_label = /** @type {((inputs?: Snapshot_History_Created_On_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Created_On_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snapshot_history_created_on_label(inputs)
	if (locale === "de") return de_snapshot_history_created_on_label(inputs)
	if (locale === "it") return it_snapshot_history_created_on_label(inputs)
	if (locale === "ru") return ru_snapshot_history_created_on_label(inputs)
	if (locale === "es") return es_snapshot_history_created_on_label(inputs)
	if (locale === "zh-CN") return zh_cn2_snapshot_history_created_on_label(inputs)
	if (locale === "ja") return ja_snapshot_history_created_on_label(inputs)
	if (locale === "hi") return hi_snapshot_history_created_on_label(inputs)
	if (locale === "pt-PT") return pt_pt2_snapshot_history_created_on_label(inputs)
	return en_snapshot_history_created_on_label(inputs)
});